export default __webpack_public_path__ + "static/media/wem_logo.cabc069f.svg";